import { buildAuthHeaders, handleUnauthorized, isPublicApiUrl } from 'utils/authToken'

function resolveRequestUrl(input) {
    if (typeof input === 'string') return input
    if (input instanceof Request) return input.url
    return ''
}

/**
 * fetch wrapper that attaches JWT Bearer token to protected API calls
 * and redirects to sign-in on 401.
 */
export async function apiFetch(input, init = {}) {
    const url = resolveRequestUrl(input)
    const headers = buildAuthHeaders(url, init.headers)

    const response = await fetch(input, {
        ...init,
        headers,
    })

    if (response.status === 401 && !isPublicApiUrl(url)) {
        handleUnauthorized()
    }

    return response
}

export { handleUnauthorized }
export default apiFetch
